<template>
  <section class="mt-5">
    <h2>会員サイトご利用登録</h2>
    <div class="form-navi mb-5">
      <ul class="d-flex">
        <li>入力</li>
        <li>確認</li>
        <li class="here">送信完了</li>                
      </ul>
    </div>
    <p class="my-5">ご入力頂いたメールアドレス宛に「本登録お手続きのお願い」メールを送付致しました。<br />
      メールが届きましたら、メールの内容に従い、本登録をお願いします。</p>
    <p class="box-p-20 text-center mb-5">
      <router-link to="/login">
        <button type="submit" name="btnEnd" id="End" class="back-01">ログイン画面へ戻る</button>
      </router-link>
    </p>
  </section>
  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br>
      ◆お問い合わせ:0120-268-510<br>
      ◆商品相談窓口:0120-649-510
    </p>
  </div>
</template>
<script>
import Authenticate from "@/modules/Authenticate";
let auth = new Authenticate();
export default {
  mounted() {
    auth.removeNoLoginUid();  
    window.scroll(0, 0);
  },
}
</script>